import React, { forwardRef } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Uploader from '../../components/Uploader';

const MissingVideoModal = forwardRef((props, ref) => {

    const {show, onHide, fixtureId} = props;

    return <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        centered
    >
        <Modal.Header>
            <Modal.Title>
                <h3>
                    Missing Video
                </h3>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row>
                <Col>
                    <Uploader onUploadComplete={() => {
                        window.location.reload();
                    }} videoId='' fixtureId={fixtureId}></Uploader>
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={onHide}>Live Matches</Button>
        </Modal.Footer>
    </Modal>;
});

export default MissingVideoModal;